import { render, staticRenderFns } from "./SocialPostMessageCounter.vue?vue&type=template&id=3575266f&scoped=true&"
import script from "./SocialPostMessageCounter.vue?vue&type=script&lang=js&"
export * from "./SocialPostMessageCounter.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostMessageCounter.vue?vue&type=style&index=0&id=3575266f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575266f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3575266f')) {
      api.createRecord('3575266f', component.options)
    } else {
      api.reload('3575266f', component.options)
    }
    module.hot.accept("./SocialPostMessageCounter.vue?vue&type=template&id=3575266f&scoped=true&", function () {
      api.rerender('3575266f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialPostMessageCounter.vue"
export default component.exports